import {
	IsArray,
	IsEmail,
	IsNotEmpty,
	IsOptional,
	IsString,
	IsUUID,
	ArrayNotEmpty,
} from 'class-validator';

export class SendEmailDto {
	@IsEmail()
	to: string;

	@IsString()
	subject: string;

	@IsString()
	body: string;
}

export class SendWeeklySummaryDto {
	@IsUUID('4')
	@IsNotEmpty()
	userId: string;
}

export class SendEventEmailDto {
	@IsUUID('4')
	@IsNotEmpty()
	eventId: string;

	@IsOptional()
	@IsArray()
	@IsUUID('4', { each: true })
	userIds?: string[];
}

export class SendEventEmailWithSampleDto extends SendEventEmailDto {
	@IsOptional()
	@IsUUID('4')
	sampleUserId?: string;
}

export class SendWaitlistNotifyDto {
	@IsString()
	eventId: string;

	@IsOptional()
	@IsString()
	waitlistId?: string;
}

/** Admin "send now" for an NFL or EPL lifecycle email. */
export class SendProbabilityEmailDto {
	@IsUUID()
	eventId: string;

	/** e.g. `probability_nfl_weekly_digest`; the API lists the accepted values on a bad request. */
	@IsString()
	emailType: string;

	/** Only these users (a test send); everyone eligible when omitted. */
	@IsOptional()
	@IsArray()
	@ArrayNotEmpty()
	@IsUUID('all', { each: true })
	userIds?: string[];
}
